import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { map } from 'rxjs/operators';
import { CommonFunctionsService } from 'src/app/service/common-functions.service';
import { mapParamsToStatusPage, StatusPageParams } from './status-model';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent implements OnInit {

  statusPageParams : StatusPageParams = {} as StatusPageParams;
  buttonOptions: any = {
    backToLogin: {
      color: 'accent',
      text: 'BACK_TO_LOGIN',
      alignment: 'right',
      type: 'proceed',
      underline: 'none'
    }
  }

  constructor(private route: ActivatedRoute, public commonFunc: CommonFunctionsService) {}

  ngOnInit(): void {
   this.route.paramMap.pipe(map((paramMap) => mapParamsToStatusPage(paramMap.get('status_type')))).subscribe((params: StatusPageParams) => {
    this.statusPageParams = params;
    })
  }

}
